<template>
  <main>
    <b-container>
      <p class="main-title">
        Tájékoztatók
      </p>
      <b-card>
        <p class="tajekoztato-title">
          Ajánlott oltási program nyulak számára
        </p>
        <p class="tajekoztato-text">
          A <span class="tajekoztato-higlight2">nyulak</span> számára is vannak ajánlott védőoltások. Hazánkban szúnyogok terjesztik  a <span class="tajekoztato-higlight2">myxomatózis</span> és a <span class="tajekoztato-higlight2">nyulak vérzéses betegsége</span> nevű rendkívül veszélyes, halálos kimenetelű betegségeket, melyeket a nyulak egyetlen csípéssel is elkaphatnak.
        </p>
        <ul>
          <li class="tajekoztato-text">
            6 hetes kortól : <span class="tajekoztato-higlight1">Kombinált oltás</span> (Myxomatózis és Nyulak Vérzéses Betegsége (RHD) ellen )
          </li>
          <li class="tajekoztato-text">
            3-4 hét múlva <span class="tajekoztato-higlight1">Kombinált oltás</span> (Myxomatózis és Nyulak Vérzéses Betegsége (RHD) ellen ) ismétlés
          </li>
        </ul>
        <p class="tajekoztato-text">
          6 havonta ismételni ajánlott!
        </p>
      </b-card>
    </b-container>
  </main>
</template>

<script>
export default {
    name: "AltalanosOlt"
}
</script>

<style lang="scss" scoped>
@import "../../sass/settings";
.card{
    border-radius: 0;
    border: none;
    padding: 60px 40px;
    .card-body{
        margin: 0;
        padding: 0;
    }
    ul{
        margin: 24px 0 8px;
        list-style: none;
        li{
            margin: 0;
            &::before{
                content: "\2022";
                color: $primary;
                font-weight: bolder;
                display: inline-block;
                width: 1em;
                margin-left: -1em;
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
}
@media screen and (max-width: 765px){
    main{
        background-color: #fff;
        .main-title{
            margin-left: 20px;
        }
    }
    .container{
        margin: 0;
        padding: 0;
        width: 100vw;
        max-width: 100%;
        &>.card{
            width: calc(100vw - 20px);
            margin: 0;
            padding: 20px;
        }
    }
}
</style>
